import { SensorFormData } from "../../definitions/sensor";

export const FORM_DEFAULT_VALUES: SensorFormData = {
  sensorId: '',
  purchaseOrderId: null,
  sensorModelId: null,
  clientId: null,
  useCaseId: null,
  sensorBillableStatusId: null,
  siteId: null,
  statusId: null,
  vendorId: null,
  vendorContactId: null,
  cost: null,
  installDate: null,
  receivedDate: null,
  rmaReturnedToSupplierDate: null,
  rmaReturnedFromSupplierDate: null,
  warrantyExpiration: null,
  writtenOffDate: null,
  rmaNumber: null,
  leadTime: '',
  rmaReplacementSensorId: '',
  comment: '',
};
